// @flow
import I18n from './i18n';

export default class FormatService {
  static formatPhone = (value: ?string, isInternational: ?boolean): string => {
    if (!value) {
      return '';
    }

    const onlyNums = value
      .replace(/[^\d]/g, '')
      .split('')
      .map((number, index) => (index % 2 !== 0 && index > 0 ? number + ' ' : number))
      .join('')
      .trim();

    if (isInternational === true && onlyNums.substr(0, 3) !== '06 ' && onlyNums.substr(0, 3) !== '07 ') {
      return '0' + onlyNums.substr(4);
    }

    return onlyNums;
  };

  static formatBirthdate = (value: ?string): string => {
    if (!value) {
      return '';
    }
    const onlyNums = value.replace(/[^\d]/g, '');
    if (onlyNums.length > 2 && onlyNums.length <= 4) {
      return onlyNums.slice(0, 2) + '/' + onlyNums.slice(2);
    }
    if (onlyNums.length > 4) {
      return onlyNums.slice(0, 2) + '/' + onlyNums.slice(2, 4) + '/' + onlyNums.slice(4);
    }
    return onlyNums;
  };

  static formatCentsToCurrency = (value: number | string, addCurrencySymbol: boolean = false): string => {
    if (value == null || Number.isNaN(Number(value))) {
      return I18n.toPrice(0);
    }

    const currencyPrice = Number(value) / 100;
    const formattedPrice = currencyPrice % 1 !== 0 ? currencyPrice.toFixed(2) : currencyPrice;

    if (addCurrencySymbol) {
      return I18n.toPrice(formattedPrice);
    }

    return `${formattedPrice}`;
  };
}
